<template>
  <ul v-if="messages.length > 0"
      class="ui-state-error"
      role="alert"
      aria-atomic="true"
      aria-live="polite">
    <validation-message v-for="message in messages" :key="message.code" :message="message"/>
  </ul>
</template>
<script>
import ValidationMessage from './ValidationMessage'
export default {
  name: 'RegistrationFormValidationMessage',
  components: {
    ValidationMessage
  },
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/registration-form/ValidationMessages.vue